module.exports = __webpack_public_path__ + "static/media/notFound.7e8a130e.png";